import { useState } from "react";
import { MapPin } from "lucide-react";
import Sidebar from "@/components/sidebar";
import FleetMap from "@/components/fleet-map";
import FleetStatusCards from "@/components/fleet-status-cards";
import MobileMenuButton from "@/components/ui/mobile-menu-button.jsx";
import FilterComboboxes from "@/components/filter-comboboxes";
import FilterDrawer from "@/components/filter-drawer";
import PageHeader from "@/components/page-header.jsx";
import PageHeaderActions from "@/components/page-header-actions.jsx";
import { useFilters } from "@/hooks/useFilters";

export default function Map() {
  /** @type {[boolean, Function]} */
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Use the custom filters hook
  const { filters, handleFilterChange, handleStatusClick, clearFilters } =
    useFilters();

  return (
    <div className='flex h-screen bg-background relative'>
      {/* Mobile menu button */}
      <MobileMenuButton
        isOpen={isMobileMenuOpen}
        onToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      {/* Sidebar */}
      <Sidebar
        key='persistent-sidebar'
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {/* Main Content */}
      <div className='flex-1 flex flex-col overflow-hidden transition-all duration-200 ease-in-out'>
        <PageHeader
          icon={MapPin}
          title='Fleet Map'
          subtitle='View compressor locations and status across all sites'>
          <PageHeaderActions />
        </PageHeader>

        {/* Main Content with proper spacing */}
        <div className='flex-1 overflow-auto p-4 sm:p-6'>
          <div className='space-y-6'>
            {/* Fleet Status Cards */}
            <FleetStatusCards
              onStatusClick={handleStatusClick}
              activeFilters={filters.status}
              filters={filters}
              searchTerm=''
            />

            {/* Filter Drawer */}
            <FilterDrawer
              filters={filters}
              onFilterChange={handleFilterChange}
              onClearFilters={clearFilters}
              onStatusClick={handleStatusClick}
              searchTerm=''
            />

            {/* Map Container */}
            <div
              className='w-full z-10'
              style={{ minHeight: "400px", height: "calc(100vh - 360px)" }}>
              <FleetMap filters={filters} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
